import { getToken } from "@/utils/tool.js";
import axios from "axios";
import { ElMessage } from "element-plus";
const { VUE_APP_API_ROOT } = process.env;
const service = axios.create({
  baseURL: VUE_APP_API_ROOT,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
	"HTTP_X_FORWARDED_FOR":"zxscg.com",
  },
  withCredentials: false,
});

service.interceptors.request.use((config) => {
  if (getToken()) {
    config.headers.Authorization = `Bearer ${getToken()}`;
  }
  return config;
});

service.interceptors.response.use(
  (res) => {
    //响应成功
    if (res.status == 200) {
      return res.data;
    }
  },
  (response) => {
    if (response.response.status == 401) {
      localStorage.setItem("userName", "");
      ElMessage.error(response.response.data.msg);
    }
    //响应失败
    return response;
  }
);

export default service;
